// The permissions the console gates pages and nav items on (D51), over `/api/me`
// (access.ts). The names are docs/12's catalogue, typed so a misspelt gate fails to compile;
// a Super Admin holds every one, including any added later.
import { useQuery } from "@tanstack/react-query";

import { accessQuery, can as listed } from "./access";

export const PERMISSIONS = [
  "ViewUsers", "InviteUser", "UpdateUser", "DisableUser", "ResetUserPassword",
  "ViewRoles", "ViewPermissions", "CreateRole", "UpdateRole", "RemoveRole", "UpdateRolePermissions", "AssignUserRole",
  "ViewWorkflows", "CreateWorkflow", "UpdateWorkflow", "DeleteWorkflow", "UpdateWorkflowStatus", "PublishWorkflow", "ManageTaskTypes",
  "ModerateWorkflowReviews", "ManageRatingWeights",
  "BrowseMarketplace",
  "ManageOwnTaskGroups", "ManageOwnTasks", "ViewOwnCosts", "AnswerOwnApprovals", "ManageOwnEnvironments", "CustomiseWorkerImage",
  "ManagePlatformCredentials", "ViewAllCosts", "ViewAllTaskGroups", "ViewAudit", "ViewResourceLimits", "ManageResourceLimits",
  "ManageOwnSecrets", "ManageOwnDevices",
  "ViewSkills", "ManageSkills",
] as const;
export type Permission = (typeof PERMISSIONS)[number];

export interface Permissions {
  /** False until `/api/me` has answered; nothing is shown as allowed before then. */
  ready: boolean;
  superAdmin: boolean;
  can: (p: Permission) => boolean;
}

export function usePermissions(): Permissions {
  const me = useQuery(accessQuery());
  const superAdmin = me.data?.role.is_super_admin ?? false;
  return {
    ready: me.data !== undefined || me.isError,
    superAdmin,
    can: (p) => superAdmin || listed(me.data, p),
  };
}
